import clsx from 'clsx';
import { ArrowPathIcon } from '@heroicons/react/20/solid';
import { Button } from '../../catalyst/button';

type Props = {
  /** A fetch is running: the button spins and waits. */
  retrying: boolean;
  onRetry: () => void;
};

/** The graph failed to load: the message and a Retry button. */
export function GraphLoadError({ retrying, onRetry }: Props) {
  return (
    <div className="flex items-center gap-3">
      <p className="text-red-600 dark:text-red-400">Failed to load the graph.</p>
      <Button outline disabled={retrying} onClick={onRetry}>
        <ArrowPathIcon data-slot="icon" className={clsx(retrying && 'animate-spin')} />
        {retrying ? 'Retrying…' : 'Retry'}
      </Button>
    </div>
  );
}
